(function () {
    'use strict';

    angular.module('PWAPoCApp').controller('DeviationModalController', deviationModalController);

    deviationModalController.$inject = [
        '$rootScope',
        '$scope',
        '$kWindow',
        '$windowInstance',
        '$timeout',
        '$q',
        'settingsService',
        'deviationService',
        'deviationList',
        'profileInfoService',
        'orderId',
        'routeStop',
        'isCallOrder',
        'setToNo',
        'setUnitsToUnselected',
        'preSelectedCategories',
        'settingKeys',
        'routeStopsService',
    ];

    function deviationModalController(
        $rootScope,
        $scope,
        $kWindow,
        $windowInstance,
        $timeout,
        $q,
        settingsService,
        deviationService,
        deviationList,
        profileInfoService,
        orderId,
        routeStop,
        isCallOrder,
        setToNo,
        setUnitsToUnselected,
        preSelectedCategories,
        settingKeys,
        routeStopsService
    ) {

        $scope.routeStop = null;
        $scope.deviations = deviationList;

        $scope.selectedAgreementLines = [];
        $scope.selectedCategories = [];
        $scope.selectedDeviations = [];
        $scope.comment = '';
        $scope.unitsWithPicture = [];
        $scope.profileInfoOfflineMsg = null;
        $scope.selectedAllCategory = false;
        $scope.profileInfos = [];
        $scope.isCommentButtonVisible;

        $timeout(initController, 250);

        var isChildModalOpen = false;
        var enableOpenImageList = true;

        function initController() {
            $scope.callOrder = isCallOrder;
            $scope.orderId = orderId;
            $scope.routeStop = routeStop;

            $rootScope.$broadcast('onDeviationWindowOpened');


            $scope.selectedAgreementLines = !setUnitsToUnselected ? _.map($scope.routeStop.units, function (u) { return u.agreementLines[0]; }) : [];

            settingsService.getCategories().then(function (categories) {
                preSelectedCategories?.forEach(function (category) {
                    $scope.toggleCategory(category);
                });
            });


            deviationService.getImagesFromCache($scope.orderId, $scope.routeStop.routeLineId).then(function (images) {
                if (images) {
                    var unitImages = _.flatten(_.map(images, 'agreementLineIds'));
                    var agreementLines = _.uniq(unitImages);
                    var unitPicCounts = _.map(agreementLines, u =>
                        ({
                            agreementLineId: u,
                            picCount: _.filter(unitImages, img => img === u).length
                        }));
                    $scope.unitsWithPicture = agreementLines;
                    $scope.unitPicCounts = unitPicCounts;
                }
            });

            if (setToNo) {
                $scope.toggleAllState = 'Nei';
                for (var i = 0; i < $scope.routeStop.units.length; i++) {
                    $scope.routeStop.units[i].message = 'Nei';
                }
            }

            if ($rootScope.isOnline) {
                $scope.profileInfoOfflineMsg = "";
                var agreementLineDataList = _.map($scope.selectedAgreementLines,
                    function (line) {
                        return {
                            agreementLineId: Number(line),
                            PASystem: $scope.routeStop.system
                        }
                    });
                if ($rootScope.loadProfileInfoData) {
                    profileInfoService.retrieveFullProfileInfo($scope.selectedAgreementLines, $scope.routeStop.system).then(function (resp) {

                        var i = 0;
                        if (agreementLineDataList.length === resp.agreementlines.length) {
                            _.forEach(_.map(agreementLineDataList, 'agreementLineId'),
                                agreementLineId => {
                                    var places = resp.places.length && resp.places[i] ? resp.places[i].data : [];
                                    var agreementLines = resp.agreementlines.length && resp.agreementlines[i] && resp.agreementlines[i].data ? resp.agreementlines[i].data : [];
                                    var agreementsData = resp.agreements.length ? _.map(_.filter(resp.agreements, { 'agreementId': resp.agreementlines[i].agreementId }), 'data') : [];
                                    var agreements = agreementsData && agreementsData.length ? agreementsData[0] : [];
                                    $scope.profileInfos[agreementLineId] = places.concat(agreements).concat(agreementLines);
                                    i++;
                                });
                        }

                        $scope.profileInfoVisible = $scope.profileInfoOfflineMsg || ($scope.loadProfileInfoData && $scope.profileInfos && $scope.profileInfos.length > 0);
                    });
                }
            } else {
                $scope.profileInfoOfflineMsg = $rootScope.translate('routeStopCard.deviations.profileInfoOfflineMsg');
            }
            setCommentButtonVisibiity();
        }

        $scope.getProfileInfos = function (unit) {
            if (unit && unit.agreementLines && unit.agreementLines.length && $scope.profileInfos && $scope.profileInfos.length) {
                return $scope.profileInfos[unit.agreementLines[0]];
            }
            return [];
        }

        $scope.imageListOpenError = function () {
            alert($rootScope.translate('routeStopCard.deviations.imageListOpenError'))
        }

        $scope.openImageList = function (isOpenCommentModalAfterClose = false) {
            if (enableOpenImageList) {
                enableOpenImageList = false;
                if (!isChildModalOpen) {
                    isChildModalOpen = true;
                    var imageWindow = $kWindow.open({
                        options: {
                            modal: true,
                            title: $rootScope.translate('routeStopCard.deviations.picture'),
                            movable: false,
                            resizable: false,
                            visible: false,
                            height: 580,
                            width: 640
                        },
                        templateUrl: 'app/routeStops/modals/image-list-modal.html',
                        windowTemplateUrl: 'app/shared/modal-base.html',
                        controller: 'ImageListModalController',
                        resolve: {
                            orderId: () => $scope.orderId,
                            routeStop: () => $scope.routeStop,
                            selectedAgreementLines: () => $scope.selectedAgreementLines,
                            enableOpenImageListCallback: () => {
                                return setEnableOpenImageList;
                            }
                        }
                    });
                    imageWindow.result
                        .then((imagesChanged) => {
                            //reload "has pictures" icons if any pictures were created or deleted
                            if (imagesChanged) {
                                deviationService.getImagesFromCache($scope.orderId, $scope.routeStop.routeLineId).then(function (images) {
                                    if (images) {
                                        var unitImages = _.flatten(_.map(images, 'agreementLineIds'));
                                        var agreementLines = _.uniq(unitImages);
                                        var unitPicCounts = _.map(agreementLines, u =>
                                            ({
                                                agreementLineId: u,
                                                picCount: _.filter(unitImages, img => img === u).length
                                            }));
                                        $scope.unitsWithPicture = agreementLines;
                                        $scope.unitPicCounts = unitPicCounts;
                                    }
                                });
                            }
                        })
                        .finally(function () {
                            enableChildModalOpening();
                            if (isOpenCommentModalAfterClose) {
                                openCommentModalAfterTimeout();
                            }
                        });
                }
            }

            function setEnableOpenImageList() {
                enableOpenImageList = true;
            }

            function preventPropagation(evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }
        }

        function getMessageParts(detailData) {
            var messageOrderData = _.find(self.orderData, function (orderDataItem) {
                return _.includes(orderDataItem.description, 'DetailData_Message');
            });

            return messageOrderData ? messageOrderData.value.split(';') : null;
        };

        $scope.toggleAll = function () {
            if ($scope.toggleAllState === 'Ja') {
                $scope.toggleAllState = 'Nei';
                var i;
                for (i = 0; i < $scope.routeStop.units.length; i++) {
                    $scope.routeStop.units[i].message = 'Nei';
                }
            }
            else {
                $scope.toggleAllState = 'Ja';
                for (i = 0; i < $scope.routeStop.units.length; i++) {
                    $scope.routeStop.units[i].message = 'Ja';
                }
            }
        }

        $scope.approve = function (evt, routeStop) {
            preventPropagation(evt);
            validateDeviation()
            .then(function(){
                $windowInstance.close(routeStop);
            })
            .catch(function(err){
                alert(err || $rootScope.translate('routeStopCard.deviations.unknownError'));
            });
        };

        // Units
        $scope.isUnitSelected = function (unit) {
            var isUnitSelected = _.find($scope.selectedAgreementLines,
                function (a) {
                    return a === unit.agreementLines[0];
                });
            return isUnitSelected;
        };

        $scope.initUnitState = function (unit) {
            if (unit.message !== 'Nei') {
                unit.message = 'Ja';
            }
        }

        $scope.toggleUnit = function (unit) {
            var agreementLine = unit.agreementLines[0];
            if ($scope.selectedAgreementLines.indexOf(agreementLine) > -1) {
                $scope.selectedAgreementLines.splice($scope.selectedAgreementLines.indexOf(agreementLine), 1);
            } else {
                $scope.selectedAgreementLines.push(agreementLine);
            }
            setCommentButtonVisibiity();
        };

        $scope.setAllUnitSelected = function (status) {
            if (status === true) {
                $scope.selectedAgreementLines = _.map($scope.routeStop.units,
                    function (u) {
                        return u.agreementLines[0];
                    });
            } else {
                $scope.selectedAgreementLines = [];
            }
        };

        $scope.hasDeviation = function (unit) {
            return _.find($scope.routeStop.deviations, { 'agreementLineId': unit.agreementLines[0] });
        };

        $scope.deviationCount = function (unit) {
            return _.filter($scope.routeStop.deviations, { 'agreementLineId': unit.agreementLines[0] }).length;
        };

        $scope.hasComment = function (unit) {
            return _.find($scope.routeStop.comments, { 'agreementLineId': unit.agreementLines[0] });
        };

        $scope.hasQRCode = function (unit) {
            return _.find($scope.routeStop.qrCodes, { 'agreementLineId': unit.agreementLines[0] });
        };

        $scope.hasPicture = function (unit) {
            return _.includes($scope.unitsWithPicture, unit.agreementLines[0]);
        };

        $scope.pictureCount = function (unit) {
            var picCountObj = _.filter($scope.unitPicCounts, u => u.agreementLineId === unit.agreementLines[0]);
            if (picCountObj && picCountObj.length) {
                return picCountObj[0].picCount;
            }
            return "";
        }

        // Categories
        $scope.getCategoryListTitle = function () {
            if (!$scope.selectedCategories.length) return '';
            const catNames = $scope.selectedCategories.map(c => c.categoryText ?? '');
            return catNames?.length ? '- ' + catNames.join(', ') : '';
        }

        $scope.getCategoryCheckboxClass = function (category) {
            if ($scope.selectedCategories.findIndex(c => c.categoryId === category.categoryId) > -1) {
                return 'glyphicon-check';
            }
            return 'glyphicon-unchecked';
        };

        $scope.toggleCategory = function (category) {
            $scope.selectedAllCategory = false;
            if ($scope.selectedCategories.findIndex(c => c.categoryId === category.categoryId) > -1) {
                $scope.selectedCategories.splice($scope.selectedCategories.findIndex(c => c.categoryId === category.categoryId), 1);
            } else {
                $scope.selectedCategories.push(category);
            }
        };

        $scope.toggleAllCategory = function () {
            if ($scope.selectedCategories.length === routeStop.deviationCategories.length && $scope.selectedAllCategory === true) {
                $scope.selectedCategories = [];
                $scope.selectedAllCategory = false;
            } else {
                $scope.selectedCategories = Object.assign([], routeStop.deviationCategories);
                $scope.selectedAllCategory = true;
            }
        };

        $scope.getAllCategoryCheckboxClass = function () {
            if ($scope.selectedCategories.length === routeStop.deviationCategories.length && $scope.selectedAllCategory === true) {
                return 'glyphicon-check';
            }
            return 'glyphicon-unchecked';
        };

        // Deviations
        $scope.getDeviationCheckboxClass = function (deviation) {
            var isDeviationSelected = getIsDeviationSelected(deviation);

            var icon = isDeviationSelected ? 'glyphicon-check' : 'glyphicon-unchecked';

            return icon;
        };

        $scope.toggleDeviation = function (deviation) {
            if (!$scope.selectedAgreementLines.length) {

                alert($rootScope.translate('routeStopCard.deviations.unitMustBeSelectedError'));
                return;
            }

            //$scope.selectedDeviations is used only privately in this controller
            const alreadySelectedIndex = $scope.selectedDeviations.findIndex(d => d.messageId === deviation.messageId);
            const isAlreadySelected = alreadySelectedIndex > -1;
            if (isAlreadySelected) {
                $scope.selectedDeviations.splice(alreadySelectedIndex, 1);
            } else {
                openModalsByDeviatonRestrictions(deviation);
                $scope.selectedDeviations.push(deviation);
            }

            _.forEach($scope.selectedAgreementLines,
                function (agreementLine) {
                    var filter = {
                        'agreementLineId': agreementLine,
                        'deviation': { 'categoryId': deviation.categoryId, 'messageId': deviation.messageId }
                    };
                    var index = _.findIndex($scope.routeStop.deviations, filter);

                    if (index > -1) {
                        $scope.routeStop.deviations.splice(index, 1);
                    } else {
                        $scope.routeStop.deviations.push({ 'agreementLineId': agreementLine, 'deviation': deviation });
                    }
                });
            setCommentButtonVisibiity();
        };

        $scope.isDeviationVisible = function (deviation) {
            if ($scope.selectedCategories.length === 0) {
                return true;
            }

            var ids = _.map($scope.selectedCategories,
                function (o) {
                    return o.categoryId * 1;
                });

            return ids.indexOf(deviation.categoryId * 1) > -1;
        };

        $scope.removeDeviations = function () {
            _.remove($scope.routeStop.deviations, function (deviation) {
                return _.includes($scope.selectedAgreementLines, deviation.agreementLineId);
            });
        };

        $scope.resetAggreementLines = function () {
            deviationService.removeImageFromCache($scope.orderId).then(function () {
                $scope.unitsWithPicture = [];
            });
            $scope.routeStop.deviations = [];
            $scope.routeStop.comments = [];
            $scope.routeStop.qrCodes = [];
        };

        $scope.openQRCodeModal = function () {
            if (!isChildModalOpen) {
                var qrCodeWindow = $kWindow.open({
                    options: {
                        modal: true,
                        title: $rootScope.translate('routeStopCard.deviations.qrCode'),
                        movable: false,
                        resizable: false,
                        visible: false,
                        width: 700,
                        height: 510,
                    },
                    templateUrl: 'app/routeStops/modals/qrcode-modal-view.html',
                    windowTemplateUrl: 'app/shared/modal-base.html',
                    controller: 'qrCodeModalController'
                });

                qrCodeWindow.result
                    .then(qrCode => {
                        if (qrCode) {
                            //Ensure qrCodes array exists for backward compatibility
                            $scope.routeStop.qrCodes = $scope.routeStop.qrCodes || [];

                            //Add or update qrCode values
                            $scope.selectedAgreementLines.forEach(agreementLineId => {
                                let existingQRCode = $scope.routeStop.qrCodes.find(qr => qr.agreementLineId === agreementLineId);
                                if (existingQRCode) {
                                    existingQRCode.code = qrCode;
                                } else {
                                    $scope.routeStop.qrCodes.push({
                                        agreementLineId: agreementLineId,
                                        qrCode: qrCode
                                    });
                                }
                            });
                        }
                    })
                    .finally(() => {
                        enableChildModalOpening();

                        if ($rootScope.video && $rootScope.video.srcObject && $rootScope.video.srcObject.getTracks()) {
                            $rootScope.video.srcObject.getTracks().forEach(track => track.stop());
                            delete $rootScope.video;
                        }
                    });
            }
        }

        $scope.openCommentModal = function () {
            if (!isChildModalOpen) {
                isChildModalOpen = true;

                var commentWindow = $kWindow.open({
                    options: {
                        modal: true,
                        title: $rootScope.translate('routeStopCard.deviations.comment'),
                        movable: false,
                        resizable: false,
                        visible: false,
                        width: '50%'
                    },
                    templateUrl: 'app/routeStops/modals/comment-modal-view.html',
                    windowTemplateUrl: 'app/shared/modal-base.html',
                    controller: 'commentModalController',
                    resolve: {
                        routeStop: function () {
                            return $scope.routeStop;
                        },
                        selectedAgreementLines: function () {
                            return $scope.selectedAgreementLines;
                        }
                    }
                });

                commentWindow.result
                    .finally(function () {
                        enableChildModalOpening();
                    });
            }

        }

        $scope.OkButtonEnabled = function () {
            if (!isAtLeastOneDeviationRequired()) {
                return true;
            }
            return isAtLeastOneDeviationChecked();
        }

        // Private functions
        function setCommentButtonVisibiity() {
            if ($scope.routeStop.deviations.length > 0) {
                const hasSelectedUnitDevitaion = _.some($scope.routeStop.deviations, deviation => _.includes($scope.selectedAgreementLines, deviation.agreementLineId));
                $scope.isCommentButtonVisible = hasSelectedUnitDevitaion;
            } else {
                $scope.isCommentButtonVisible = false;
            }
        }

        function getIsDeviationSelected(deviation) {
            return $scope.selectedAgreementLines.length > 0 &&
                $scope.routeStop.deviations.length > 0 &&
                _.every($scope.selectedAgreementLines,
                    function (agreementLine) {
                        var filter = {
                            'agreementLineId': agreementLine,
                            'deviation': { 'categoryId': deviation.categoryId, 'messageId': deviation.messageId }
                        };
                        const found = _.find($scope.routeStop.deviations, filter);
                        return found;
                    });
        }

        function isAtLeastOneDeviationChecked() {
            if ($scope.routeStop) {
                var deviations = $scope.deviations;
                for (var i = 0; i < deviations.length; i++) {
                    if (getIsDeviationSelected(deviations[i])) {
                        return true;
                    }
                }
            }

            return false;
        }

        function isAtLeastOneDeviationRequired() {
            return $rootScope.noButtonRequiresDeviation && $scope.routeStop && _.filter($scope.routeStop.units, u => u.message === 'Nei').length;
        }

        function enableChildModalOpening() {
            setTimeout(function () {
                $scope.$applyAsync(function () {
                    isChildModalOpen = false;
                });
            }, 500);
        }

        function openCommentModalAfterTimeout() {
            setTimeout(function () {
                $scope.$applyAsync(function () {
                    $scope.openCommentModal();
                });
            }, 500);
        }

        function hasCharInDeviationList(deviationList, char, charNotToBeIncluded = '') {
            const hasChar = deviationList.some(deviation => deviation.text.includes(char) && (charNotToBeIncluded ? !deviation.text.includes(charNotToBeIncluded) : true));
            return hasChar;
        }

        function getDeviationMapWithSpecificChar(char, charNotToBeIncluded = '') {
            const deviationMap = $scope.routeStop.deviations.filter(deviation => deviation.deviation.text.includes(char) && (charNotToBeIncluded ? !deviation.deviation.text.includes(charNotToBeIncluded) : true)).reduce((map, deviation) => {
                const { agreementLineId, deviation: { text } } = deviation;
                map[agreementLineId] = map[agreementLineId] || [];
                map[agreementLineId].push(text);
                return map;
              }, {});
            return deviationMap;
        }

        function isCommentRequiredByVehicleSetting(){
            const defer = $q.defer();
            settingsService.getOne(settingKeys.IsDeviationCommentConditionalRequired)
                .then(function (isDeviationCommentConditionalRequired) {
                    if (isDeviationCommentConditionalRequired) {
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                })
                .catch(function(){
                    defer.resolve(false);
                });

            return defer.promise;
        }

        function isPictureRequiredByVehicleSetting(){
            const defer = $q.defer();
            settingsService.getOne(settingKeys.IsDeviationPictureConditionalRequired)
                .then(function (isDeviationPictureConditionalRequired) {
                    if (isDeviationPictureConditionalRequired) {
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                })
                .catch(function(){
                    defer.resolve(false);
                });

            return defer.promise;
        }

        function isPictureRequiredByDeviationText(unit){
            const deviationsByUnit = $scope.routeStop.deviations.filter(deviation => deviation.agreementLineId === unit.agreementLines[0]).map(deviation => deviation.deviation);
            const isPictureRequired = hasCharInDeviationList(deviationsByUnit, '**');
            return isPictureRequired;
        }

        function isCommentRequiredByDeviationText(unit){
            const deviationsByUnit = $scope.routeStop.deviations.filter(deviation => deviation.agreementLineId === unit.agreementLines[0]).map(deviation => deviation.deviation);
            const isCommentRequired = hasCharInDeviationList(deviationsByUnit, '*', '**');
            return isCommentRequired;
        }
        
        function isPictureRequiredBySelectedDeviation(toggledDeviation) {
            const isPictureRequired = hasCharInDeviationList([toggledDeviation], '**');
            return isPictureRequired;
        }

        function isCommentRequiredBySelectedDeviation(toggledDeviation) {
            const isCommentRequired = hasCharInDeviationList([toggledDeviation], '*', '**');
            return isCommentRequired;
        }

        function openModalsByDeviatonRestrictions(toggledDeviation) {
            const promiseArray = [isCommentRequiredByVehicleSetting(), isPictureRequiredByVehicleSetting()];
            $q.all(promiseArray)
                .then(function (results) {
                    const [isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting] = results;
                    const needBoth = isCommentOrPictureMissingForAnySelectedAgreementLines(toggledDeviation, isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting);
                    const needComment = isCommentMissingForAnySelectedAgreementLines(toggledDeviation, isCommentRequiredByVehicleSetting);
                    const needPicture = isPictureMissingForAnySelectedAgreementLines(toggledDeviation, isPictureRequiredByVehicleSetting);
                    if (needBoth) {
                        alert($rootScope.translate('routeStopCard.deviations.pictureAndCommentRequiredWarning'));
                        $scope.selectedAgreementLines.length || $scope.unitPicCounts.length ? $scope.openImageList(true) : $scope.imageListOpenError();
                    }
                    else if (needComment) {
                        alert($rootScope.translate('routeStopCard.deviations.commentRequiredWarning'));
                        $scope.openCommentModal();
                    }
                    else if (needPicture) {
                        alert($rootScope.translate('routeStopCard.deviations.pictureRequiredWarning'));
                        $scope.selectedAgreementLines.length || $scope.unitPicCounts.length ? $scope.openImageList() : $scope.imageListOpenError();
                    }
        
        });
        }

        function isCommentMissingForAnySelectedAgreementLines(toggledDeviation, isCommentRequiredByVehicleSetting) {
            const hasUnitWithMissingComment = 
            $scope.routeStop.units.filter(unit => $scope.selectedAgreementLines.includes(unit.agreementLines[0])).some((unit) => {
                    const hasUnitWithoutComment = !$scope.hasComment(unit);
                    return hasUnitWithoutComment;
                }
            );
            return hasUnitWithMissingComment && isCommentRequiredByVehicleSetting && isCommentRequiredBySelectedDeviation(toggledDeviation);
        }

        function isCommentOrPictureMissingForAnySelectedAgreementLines(toggledDeviation, isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting) {
            const hasUnitWithMissingCommentOrPicture = 
            $scope.routeStop.units.filter(unit => $scope.selectedAgreementLines.includes(unit.agreementLines[0])).some((unit) => {
                    const hasUnitWithoutCommentOrPicture = !$scope.hasComment(unit) || !$scope.hasPicture(unit);
                    return hasUnitWithoutCommentOrPicture;
                }
            );
            return hasUnitWithMissingCommentOrPicture && isCommentRequiredByVehicleSetting && isPictureRequiredByVehicleSetting && isPictureRequiredBySelectedDeviation(toggledDeviation);
        }

        function isPictureMissingForAnySelectedAgreementLines(toggledDeviation, isPictureRequiredByVehicleSetting) {
            const hasUnitWithMissingPicture = 
            $scope.routeStop.units.filter(unit => $scope.selectedAgreementLines.includes(unit.agreementLines[0])).some((unit) => {
                    const hasUnitWithoutPicture = !$scope.hasPicture(unit);
                    return hasUnitWithoutPicture;
                }
            );
            return hasUnitWithMissingPicture && isPictureRequiredByVehicleSetting && isPictureRequiredBySelectedDeviation(toggledDeviation);
        }

        function getCommentIssueRelatedDeviationError(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting){
            if (!hasCommentValidationIssue(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting)) {
                return '';
            }

            const isCommentRestrictionRelated = hasCommentRelatedCommentValidationIssue(isCommentRequiredByVehicleSetting);
            const isPictureRestrictionRelated = hasPictureRelatedCommentValidationIssue(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting);
            
            if (isCommentRestrictionRelated) {
                return getOnlyCommentIssueRelatedDeviationError();
            } else if (isPictureRestrictionRelated) {
                return getCommentAndPictureIssueRelatedDeviationError();
            }
            
            return '';
        }

        function getPictureIssueRelatedDeviationError(){
            const deviationMap = getDeviationMapWithSpecificChar('**');
            const text = $scope.routeStop.units.filter(unit => deviationMap.hasOwnProperty(unit.agreementLines[0]) && !$scope.hasPicture(unit))
            .map(unit => `${unit.name}: ${deviationMap[unit.agreementLines[0]]?.join(', ')}`
            )?.join('\n') || '';

            return `${$rootScope.translate('routeStopCard.deviations.pictureRequiredWarning')}:\n${text}`;
        }

        function getOnlyCommentIssueRelatedDeviationError(){
            const deviationMap = getDeviationMapWithSpecificChar('*', '**');
            const text = $scope.routeStop.units.filter(unit => deviationMap.hasOwnProperty(unit.agreementLines[0]) && !$scope.hasComment(unit))
            .map(unit => `${unit.name}: ${deviationMap[unit.agreementLines[0]]?.join(', ')}`
            )?.join('\n') || '';

            return `${$rootScope.translate('routeStopCard.deviations.commentRequiredWarning')}:\n${text}`;
        }

        function getCommentAndPictureIssueRelatedDeviationError(){
            const deviationMap = getDeviationMapWithSpecificChar('**');
            const text = $scope.routeStop.units.filter(unit => deviationMap.hasOwnProperty(unit.agreementLines[0]) && (!$scope.hasComment(unit) || !$scope.hasPicture(unit)))
            .map(unit => `${unit.name}: ${deviationMap[unit.agreementLines[0]]?.join(', ')}`
            )?.join('\n') || '';

            return `${$rootScope.translate('routeStopCard.deviations.pictureAndCommentRequiredWarning')}:\n${text}`;
        }

        function hasCommentValidationIssue(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting){
            return hasCommentRelatedCommentValidationIssue(isCommentRequiredByVehicleSetting) || hasPictureRelatedCommentValidationIssue(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting);
        }

        function hasCommentRelatedCommentValidationIssue(isCommentRequiredByVehicleSetting) {
            const hasUnitWithMissingComment = 
            $scope.routeStop.units.some((unit) => {
                const isCommentRequiredForUnit = isCommentRequiredByVehicleSetting && isCommentRequiredByDeviationText(unit);
                const isCommentMissing = isCommentRequiredForUnit && !$scope.hasComment(unit);
                return isCommentMissing;

            });
            return hasUnitWithMissingComment;
        }

        function hasPictureRelatedCommentValidationIssue(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting) {
            const hasUnitWithMissingContent = 
            $scope.routeStop.units.some((unit) => {
                const isCommentAndPictureRequiredForUnit = isPictureRequiredByDeviationText(unit) && isCommentRequiredByVehicleSetting && isPictureRequiredByVehicleSetting;
                const isCommentOrPictureMissing = isCommentAndPictureRequiredForUnit && (!$scope.hasComment(unit) || !$scope.hasPicture(unit));
                return isCommentOrPictureMissing;

            });
            return hasUnitWithMissingContent;
        }

        function hasPictureValidationIssue(isPictureRequiredByVehicleSetting){

            const hasUnitWithMissingPicture = 
            $scope.routeStop.units.some((unit) => {
                const isPictureRequiredForUnit = isPictureRequiredByVehicleSetting && isPictureRequiredByDeviationText(unit);
                const isPictureMissing = isPictureRequiredForUnit && !$scope.hasPicture(unit);
                return isPictureMissing;

            });

            return hasUnitWithMissingPicture;
        }

        function validateDeviation() {
            const defer = $q.defer();

            const promiseArray = [isCommentRequiredByVehicleSetting(), isPictureRequiredByVehicleSetting()];
            $q.all(promiseArray)
                .then(function (results) {
                    //If a deviation has a * in it's text, it is required to have a comment
                    //If a deviation has a ** in it's text, it is required to have a photo attached
                    //If a deviation has a ** in it's text and both comment and picture is required by vehicle setting, it is required to have a comment and a photo attached
                    const [isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting] = results;
                    const commentIssue = hasCommentValidationIssue(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting);
                    const pictureIssue = hasPictureValidationIssue(isPictureRequiredByVehicleSetting);

                    const isDisabled = !$scope.OkButtonEnabled();
                    if (commentIssue) {
                        const text = getCommentIssueRelatedDeviationError(isCommentRequiredByVehicleSetting, isPictureRequiredByVehicleSetting);
                        defer.reject(text);
                    } else if (pictureIssue) {
                        const text = getPictureIssueRelatedDeviationError();
                        defer.reject(text);
                    } else if (isDisabled) {
                        defer.reject($rootScope.translate('routeStopCard.deviations.noRequiredDeviation'));
                    } else {
                        defer.resolve();
                    }
                })
                .catch(function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        }

        function preventPropagation(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    }
})();
